<template>
  <div class="form-card form-card--bare">
    <div class="form-card__body">
      <div class="form-card__field">
        <label class="form-card__label" for="cat-name">Nombre</label>
        <input
          id="cat-name"
          v-model.trim="fund_category.name"
          type="text"
          class="form-control"
          placeholder="Nombre de la categoría"
        >
        <div class="form-card__hint">Campo obligatorio.</div>
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="cat-description">Descripción</label>
        <input
          id="cat-description"
          v-model.trim="fund_category.description"
          type="text"
          class="form-control"
          placeholder="Descripción"
        >
      </div>

      <div class="form-card__field">
        <label class="form-card__label" for="cat-type">Tipo</label>
        <q-select v-model="fund_category.type" :options="typeOptions" placeholder="- Seleccionar tipo -" />
      </div>
    </div>

    <div class="form-card__footer">
      <button type="button" class="form-card__btn" @click="$emit('close')">Cancelar</button>
      <button type="button" class="form-card__btn form-card__btn--primary" @click="saveFundCategory">
        <i class="bi bi-check-lg"></i>
        Guardar categoría
      </button>
    </div>
  </div>
</template>

<script>
import QSelect from '@/components/shared/QSelect.vue';

export default {
  components: { QSelect },
  props: ["fundCategoryId"],
  data() {
    return {
      fund_category: {
        name: "",
        description: "",
        type: "",
      },
      empty_fund_category: {
        name: "",
        description: "",
        type: "",
      },
      optionsUnit: [
        { value: "in", text: "Ingreso" },
        { value: "out", text: "Egreso" },
      ],
    };
  },
  computed: {
    typeOptions() {
      return this.optionsUnit.map(opt => ({ value: opt.value, label: opt.text }));
    },
  },
  watch: {
    fundCategoryId(value) {
      if (value != null) {
        this.getFundCategory(value);
      } else {
        this.resetForm();
      }
    },
  },
  mounted() {
    this.resetForm();
    if (this.fundCategoryId != null) {
      this.getFundCategory(this.fundCategoryId);
    }
  },
  methods: {
    validateForm() {
      if (!this.fund_category.name || this.fund_category.name.trim() === "") {
        alert("Debe ingresar un nombre");
        return false;
      }
      if (!this.fund_category.type) {
        alert("Debe seleccionar un tipo");
        return false;
      }
      return true;
    },
    saveFundCategory() {
      if (!this.validateForm()) return;
      if (this.fund_category.id != null) {
        this.$http
          .post("/api/fundsCategories/edit/" + this.fund_category.id, this.fund_category)
          .then(() => {
            this.resetForm();
            this.$emit("confirmsave");
          });
      } else {
        this.$http.post("/api/fundsCategories/add", this.fund_category).then(() => {
          this.resetForm();
          this.$emit("confirmsave");
        });
      }
    },
    getFundCategory(id) {
      this.$http.get("/api/fundsCategories/view/" + id).then((response) => {
        this.fund_category = response.data.data;
      });
    },
    resetForm() {
      this.fund_category = Object.assign({}, this.empty_fund_category);
      this.$emit("reset-id");
    },
  },
};
</script>
